import _ from 'lodash'
import { attachmentsActionsCreator } from 'store/toolkit/newBooking/attachments.reducer'

export const updateAttachments = attachments =>dispatch => dispatch(attachmentsActionsCreator.updateAttachments(attachments))
export const updateAttachment = (index, attrs) =>dispatch => dispatch(attachmentsActionsCreator.updateAttachment({
  index,
  attrs
}))
